import { forkJoin, from, map, mapTo, Observable } from 'rxjs';
import Tesseract, { createScheduler, createWorker, PSM } from 'tesseract.js';
import { TextReader } from './TextReader';

export class TesseractTextReader implements TextReader {
  private scheduler: Tesseract.Scheduler;
  private workers: Tesseract.Worker[] = [];
  private numberOfWorkers = 2;

  public constructor() {
    this.scheduler = createScheduler();
    this.createWorkers();
  }

  private createWorkers(): void {
    for (let i = 0; i < this.numberOfWorkers; i++) {
      this.workers[i] = createWorker({
        // logger: console.log,
      });
      this.scheduler.addWorker(this.workers[i]);
    }
  }

  public load(): Observable<boolean> {
    return forkJoin(this.workers.map((worker) => worker.load())).pipe(mapTo(true));
  }

  public setLanguage(language: string): Observable<string> {
    return forkJoin(this.workers.map((worker) => this.setLanguageForSingleWorker(worker, language))).pipe(
      mapTo(language)
    );
  }

  private async setLanguageForSingleWorker(worker: Tesseract.Worker, language: string): Promise<void> {
    const SINGLE_LINE = '7';
    await worker.loadLanguage(language);
    await worker.initialize(language);
    await worker.setParameters({ tessedit_pageseg_mode: SINGLE_LINE as PSM });
  }

  public readImageText(image: HTMLImageElement): Observable<string> {
    return from(this.scheduler.addJob('recognize', image)).pipe(map((res) => res.data.text));
  }
}
